var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.587,
    height: 30,
    fill: "#007cc2",
    viewBox: "0 0 27.587 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79.44)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.532,10.181c-3.15-4.919-6.346-8.975-6.378-9.016L93.234,0l-.92,1.165c-.032.04-3.228,4.1-6.378,9.016-4.31,6.73-6.5,11.826-6.5,15.146C79.44,33.418,85.628,40,93.234,40s13.794-6.582,13.794-14.673C107.027,22.007,104.842,16.911,100.532,10.181Z",
    transform: "translate(-79.44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropIcon);
export default __webpack_public_path__ + "static/media/dropIcon.6237182ce2378d72165e3f244ca9fc19.svg";
export { ForwardRef as ReactComponent };